/**
 * Response Builder App Component
 * 
 * Minimal React application that renders the router.
 * Per PHASE_B_WORK_ORDERS.md B2.
 */

import { RouterProvider } from 'react-router-dom';
import { router } from './router';

export default function App() {
  return <RouterProvider router={router} />;
}
